import {ClsUtil} from 'src/app/util/cls-util';
import {ClsParametro} from "../../../core/models/cls-parametros";
import {EnumParaPpto} from "../../../core/models/enum/enum-parametros";
import {inject} from "@angular/core";
import {AppInfoService} from "../../../core/services/app-info.service";
import {AppPresupuestosService} from "../../../core/services/app-presupuestos.service";
import {GenericoService} from "../../../core/services/generico.service";
import {
  ClsPeticionUnPrograma, ClsRecibirPorcentajesFinanciamiento,
  ClsRecibirProgramas,
  ClsRespuestaUnPrograma
} from "../../../core/models/peticiones/cls-pr-programa";
import {ClsPrograma} from "../../../core/models/cls-programa";
import {
  ClsPeticionRegistraActualizaGralsCatalogos
} from "../../../core/models/peticiones/catalogos/cls-pr-catalogos";

export class ClsObjCatProgramacionObra {
  private infApp = inject(AppInfoService);
  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);

  constructor() {
  }


  public inicizalizarPrograma(): ClsPrograma {
    return {
      IdPrograma: BigInt('0'),
      NoPrograma: 0,
      Descripcion: '',
      IdCalendario: BigInt('0'),
      FechaInicio: new Date(),
      FechaFinal: new Date(),
      NoPeriodos: 1,
      Periodicidad: 1,
      CapturarPorcentaje: true,
      Vigente: false,
      DiasCalendario: 1,
      DiasHabiles: 1,
      JsonDetallePrograma: '',
      JsonRelaciones: '',
      JsonProgSum: ''
    }
  }
  public getParametrosPrograma(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaPpto.IDPROGRAMA,
        Valor: ''
      }
    ]
  }

  public async buscarUnPrograma(idPrograma: number, idPresupuesto: bigint): Promise<ClsPrograma> {
    const objPeticion: ClsPeticionUnPrograma = new ClsPeticionUnPrograma();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = idPresupuesto;
    objPeticion.IdPrograma = idPrograma;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ConsultarUnPrograma2021');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const resp: ClsRespuestaUnPrograma = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      // seteamos los valores de PorcFinanciamiento a nivel de programa
      resp.Programa.LsPorcFinanciamiento = resp.LsPorcFinanciamiento || [];
      return resp.Programa;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async agregarModificarCatalogoPrograma(objAddUpdate: any[], servicio: string, unRegistro = true): Promise<any> {
    const objPeticion: ClsPeticionRegistraActualizaGralsCatalogos = new ClsPeticionRegistraActualizaGralsCatalogos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.Catalogo = objAddUpdate;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, servicio)
      // modo offline
      if (!respuesta) {
        return null;
      }
      const addUpdate: ClsRecibirProgramas = ClsUtil.parseJSONBig(respuesta);
      if (addUpdate?.Errores?.ErrorDescripcion !== '') {
        throw new Error(addUpdate.Errores.ErrorDescripcion);
      }
      return unRegistro ? addUpdate.LsCatalogo[0] : addUpdate.LsCatalogo;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async buscarPorcentajesFinanciamiento(idPrograma: number, idPresupuesto: bigint, unRegistro = true): Promise<any> {
    const objPeticion: ClsPeticionUnPrograma = new ClsPeticionUnPrograma();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = idPresupuesto;
    objPeticion.IdPrograma = idPrograma;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ConsultarPorcentajesFinanciamiento');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const resp: ClsRecibirPorcentajesFinanciamiento = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }

      return unRegistro ? resp.LsPorcFinanciamiento[0] : resp.LsPorcFinanciamiento;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async agregarModificarPorcentajesFinanciamiento(objAddUpdate: any[], servicio: string, unRegistro = true): Promise<any> {
    const objPeticion: ClsPeticionRegistraActualizaGralsCatalogos = new ClsPeticionRegistraActualizaGralsCatalogos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.Catalogo = objAddUpdate;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, servicio)
      // modo offline
      if (!respuesta) {
        return null;
      }
      const addUpdate: ClsRecibirPorcentajesFinanciamiento = ClsUtil.parseJSONBig(respuesta);
      if (addUpdate?.Errores?.ErrorDescripcion !== '') {
        throw new Error(addUpdate.Errores.ErrorDescripcion);
      }
      return unRegistro ? addUpdate.LsPorcFinanciamiento[0] : addUpdate.LsPorcFinanciamiento;
    } catch (e) {
      throw new Error(e.message);
    }
  }

}
